function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { shuffle, union } from 'lodash';
import * as iconSources from './iconSources';
import { HttpClient } from '@wix/http-client';
import { wait } from '../../utils/promises';
import EventEmitter from 'eventemitter3';
import { EventBroker } from '@wix/branding-helpers-lib/server';
var NOUN_PROJECT_STATICS_DOMAIN = 'static.thenounproject.com';
export var LogoProviderManager = /*#__PURE__*/function (_EventEmitter) {
  _inheritsLoose(LogoProviderManager, _EventEmitter);

  function LogoProviderManager(_ref, options) {
    var _this;

    var industryService = _ref.industryService,
        logoWebappApi = _ref.logoWebappApi,
        iconsServerApi = _ref.iconsServerApi;

    if (options === void 0) {
      options = {};
    }

    _this = _EventEmitter.call(this) || this;

    _defineProperty(_assertThisInitialized(_this), "blackListIcons", [{
      id: '10419',
      source: 'npr'
    }]);

    _this.options = options;
    _this.industryService = industryService;
    _this.logoWebappApi = logoWebappApi;
    _this.iconsServerApi = iconsServerApi;
    _this.providers = [];
    _this.iconsCache = {};
    _this._httpClient = new HttpClient();
    _this._icons = [];
    _this._searchTerm = '';
    _this._searching = false;
    _this._selectedTag = '';
    _this.iconsChanged = new EventBroker(_assertThisInitialized(_this), 'iconsChanged');
    _this.searchTermChanged = new EventBroker(_assertThisInitialized(_this), 'searchTermChanged');
    _this.searchingChanged = new EventBroker(_assertThisInitialized(_this), 'searchingChanged');
    _this.selectedTagChanged = new EventBroker(_assertThisInitialized(_this), 'selectedTagChanged');
    return _this;
  } // use EventBroker


  var _proto = LogoProviderManager.prototype;

  _proto.validateSource = function validateSource(source) {
    var errMsg;

    if (!source) {
      errMsg = 'No source';
    } else if (typeof source !== 'string') {
      errMsg = 'source is not a string';
    }

    if (errMsg) {
      throw new Error(errMsg);
    }
    /* TODO:
    else if (this.providers[source]) {
      throw 'source already exists';
    } */

  };

  _proto.validateProvider = function validateProvider(provider) {
    if (!provider) {
      throw new Error('no provider');
    } // TODO: check inheritance

  };

  _proto._validateSearchTerms = function _validateSearchTerms(arrSearchTerms) {
    if (!Array.isArray(arrSearchTerms)) {
      throw new Error('Search terms is not an array');
    }
  };

  _proto.addProvider = function addProvider(iconProvider) {
    this.validateProvider(iconProvider);
    this.providers.push(iconProvider);
  };

  _proto._shouldIncludeProvider = function _shouldIncludeProvider(provider, options) {
    var hasDefault = provider.hasDefault();
    var preventDefaultResults = !!options.preventDefaultResults;
    var isAllowed = true;

    if (preventDefaultResults && hasDefault) {
      isAllowed = false;
    }

    return isAllowed;
  };

  _proto._searchIcons = /*#__PURE__*/function () {
    var _searchIcons2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(arrItems, index, arrSearchTerms, options) {
      var results, provider, shouldIncludeProvider, providerResults;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              results = [];
              provider = arrItems[index];

              if (!provider) {
                _context.next = 17;
                break;
              }

              shouldIncludeProvider = this._shouldIncludeProvider(provider, options);
              _context.t0 = shouldIncludeProvider;

              if (!_context.t0) {
                _context.next = 9;
                break;
              }

              _context.next = 8;
              return provider.searchIconsWithSource(arrSearchTerms, options);

            case 8:
              _context.t0 = _context.sent;

            case 9:
              providerResults = _context.t0;

              if (!(!providerResults || Array.isArray(providerResults) && !providerResults.length)) {
                _context.next = 16;
                break;
              }

              _context.next = 13;
              return this._searchIcons(arrItems, index + 1, arrSearchTerms, options);

            case 13:
              results = _context.sent;
              _context.next = 17;
              break;

            case 16:
              results = providerResults;

            case 17:
              return _context.abrupt("return", results);

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function _searchIcons(_x, _x2, _x3, _x4) {
      return _searchIcons2.apply(this, arguments);
    }

    return _searchIcons;
  }();

  _proto._cacheSearchedIcons = function _cacheSearchedIcons(searchResults) {
    var _this2 = this;

    // We can't allow the application crash because of this
    if (this.options.useIconsCache) {
      try {
        searchResults.forEach(function (icon) {
          var newIcon = iconSources.fromOldIconToNewIcon(icon);
          var id = newIcon.id,
              source = newIcon.source,
              iconUrl = newIcon.iconUrl;

          var iconCacheKey = _this2.getCacheKey(id, source);

          if (!_this2.iconsCache[iconCacheKey]) {
            _this2.iconsCache[iconCacheKey] = {
              id: id,
              source: source,
              pending: false,
              iconUrl: iconUrl
            };
          }
        });
      } catch (error) {
        console.error("LogoProviderManager - _cacheSearchedIcons " + error.message);
      }
    } else {
      this.iconsCache = {};
    }
  };

  _proto.defaultAggregator = function defaultAggregator(arrResults) {
    var results = [];
    var combinedList = arrResults.reduce(function (previous, currentResultSet) {
      return [].concat(previous, [].concat(currentResultSet));
    }, []);
    var totalIcons = combinedList.reduce(function (previous, current) {
      return previous + current.length;
    }, 0);
    var i = 0;

    while (totalIcons) {
      var searchResultIndex = i % combinedList.length;
      var searchResult = combinedList[searchResultIndex];
      var result = searchResult.splice(0, 1);

      if (result.length === 1) {
        totalIcons--;
        results.push(result[0]);
      }

      i++;
    }

    return results;
  };

  _proto.filterBlackListIcons = function filterBlackListIcons(icons) {
    if (icons === void 0) {
      icons = [];
    }

    this.blackListIcons.forEach(function (blackListIcon) {
      var foundBlackListIconIndex = icons.findIndex(function (icon) {
        return icon.id === blackListIcon.id && icon.source === blackListIcon.source;
      });

      if (foundBlackListIconIndex !== -1) {
        icons.splice(foundBlackListIconIndex, 1);
      }
    });
    return icons;
  };

  _proto.searchIcons = /*#__PURE__*/function () {
    var _searchIcons3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(arrSearchTerms, options) {
      var _options, limit, providers, providersSearches, searchResults, finalResult;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (options === void 0) {
                options = {};
              }

              this._validateSearchTerms(arrSearchTerms);

              _options = options, limit = _options.limit;
              providers = this.providers;
              providers = this.providers.filter(function (provider) {
                return provider.getSource() !== iconSources.NOUN_PROJECT_SOURCE;
              });
              providersSearches = this._searchIcons(providers, 0, arrSearchTerms, options);
              _context2.next = 8;
              return providersSearches;

            case 8:
              searchResults = _context2.sent.filter(function (result) {
                return result;
              });

              this._cacheSearchedIcons(searchResults);

              finalResult = this.filterBlackListIcons(searchResults);

              if (limit) {
                finalResult = finalResult.splice(0, limit);
              }

              return _context2.abrupt("return", finalResult);

            case 13:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function searchIcons(_x5, _x6) {
      return _searchIcons3.apply(this, arguments);
    }

    return searchIcons;
  }();

  _proto.getCacheKey = function getCacheKey(id, source) {
    return "" + id + source;
  };

  _proto.getSVG = /*#__PURE__*/function () {
    var _getSVG = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(iconUrl) {
      var isNounUrl, httpOptions, response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              isNounUrl = iconUrl.indexOf(NOUN_PROJECT_STATICS_DOMAIN) !== -1;

              if (isNounUrl) {
                httpOptions = {
                  // Solves weird bug where sometimes the download fails if it gets from cache
                  headers: {
                    'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=-1,private'
                  }
                };
              }

              _context3.next = 4;
              return this._httpClient.get(iconUrl, _objectSpread(_objectSpread({}, httpOptions), {}, {
                disableWixHeaders: true
              }));

            case 4:
              response = _context3.sent;
              return _context3.abrupt("return", response.data);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function getSVG(_x7) {
      return _getSVG.apply(this, arguments);
    }

    return getSVG;
  }();

  _proto.getIconSvgFromIdAndSource = /*#__PURE__*/function () {
    var _getIconSvgFromIdAndSource = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(iconId, source, contextId, waitForCacheCount) {
      var _this3 = this;

      var iconCacheKey, iconFromCache, svg, getSvgAndSetCache;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (waitForCacheCount === void 0) {
                waitForCacheCount = 15;
              }

              iconCacheKey = this.getCacheKey(iconId, source);
              iconFromCache = this.iconsCache[iconCacheKey];

              getSvgAndSetCache = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(givenIconUrl) {
                  var finalIconUrl, _yield$_this3$logoWeb, url;

                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          finalIconUrl = givenIconUrl;

                          if (finalIconUrl) {
                            _context4.next = 7;
                            break;
                          }

                          _context4.next = 4;
                          return _this3.logoWebappApi.getIconUrlByIdAndSource(iconId, source, contextId);

                        case 4:
                          _yield$_this3$logoWeb = _context4.sent;
                          url = _yield$_this3$logoWeb.url;
                          finalIconUrl = url.replace('/esh/noun/', '/noun/');

                        case 7:
                          _context4.next = 9;
                          return _this3.getSVG(finalIconUrl);

                        case 9:
                          svg = _context4.sent;
                          _this3.iconsCache[iconCacheKey] = {
                            iconId: iconId,
                            source: source,
                            pending: false,
                            iconUrl: finalIconUrl,
                            svg: svg
                          };

                        case 11:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function getSvgAndSetCache(_x12) {
                  return _ref2.apply(this, arguments);
                };
              }();

              if (iconFromCache) {
                _context5.next = 10;
                break;
              }

              this.iconsCache[iconCacheKey] = {
                iconId: iconId,
                source: source,
                pending: true
              };
              _context5.next = 8;
              return getSvgAndSetCache();

            case 8:
              _context5.next = 29;
              break;

            case 10:
              if (!(iconFromCache.pending && waitForCacheCount !== 0)) {
                _context5.next = 18;
                break;
              }

              _context5.next = 13;
              return wait(1000);

            case 13:
              _context5.next = 15;
              return this.getIconSvgFromIdAndSource(iconId, source, contextId, waitForCacheCount - 1);

            case 15:
              svg = _context5.sent;
              _context5.next = 29;
              break;

            case 18:
              if (!iconFromCache.svg) {
                _context5.next = 22;
                break;
              }

              svg = iconFromCache.svg;
              _context5.next = 29;
              break;

            case 22:
              if (!iconFromCache.iconUrl) {
                _context5.next = 27;
                break;
              }

              _context5.next = 25;
              return getSvgAndSetCache(iconFromCache.iconUrl);

            case 25:
              _context5.next = 29;
              break;

            case 27:
              _context5.next = 29;
              return getSvgAndSetCache();

            case 29:
              if (svg.indexOf(/\sxlink:href="[^"]*"/) > -1) {
                console.error("icon contains href: " + iconId + " - " + source);
              }

              return _context5.abrupt("return", svg);

            case 31:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, this);
    }));

    function getIconSvgFromIdAndSource(_x8, _x9, _x10, _x11) {
      return _getIconSvgFromIdAndSource.apply(this, arguments);
    }

    return getIconSvgFromIdAndSource;
  }();

  _proto.searchIconsByIds = function searchIconsByIds(arrIcons) {
    var _this4 = this;

    // TODO: TAL - validation
    var iconsPromises = arrIcons.map(function (_ref3) {
      var id = _ref3.id,
          source = _ref3.source;
      return _this4.getIconDataById(id, source);
    });
    return Promise.all(iconsPromises);
  };

  _proto.findProviderBySource = function findProviderBySource(source) {
    var sourceToGetProvider = source;

    if (source === iconSources.NOUN_PROJECT_SOURCE || source === iconSources.WIX_CMS_SOURCE || source === iconSources.NEW_WIX_CMS) {
      sourceToGetProvider = iconSources.WIX_NOUN_PROJECT_SOURCE;
    }

    var provider = this.providers.find(function (_provider) {
      var providerSource = _provider.getSource();

      return providerSource === sourceToGetProvider && _provider;
    });

    if (provider) {
      return provider;
    }
  };

  _proto.getIconDataById = /*#__PURE__*/function () {
    var _getIconDataById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id, source) {
      var provider, icon;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              this.validateSource(source);
              provider = this.findProviderBySource(source);
              this.validateProvider(provider);

              if (!provider) {
                _context6.next = 8;
                break;
              }

              _context6.next = 6;
              return provider.getIconById(id, source);

            case 6:
              icon = _context6.sent;
              return _context6.abrupt("return", _objectSpread({
                source: source
              }, icon));

            case 8:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this);
    }));

    function getIconDataById(_x13, _x14) {
      return _getIconDataById.apply(this, arguments);
    }

    return getIconDataById;
  }();

  _proto.getDefaultIcons = /*#__PURE__*/function () {
    var _getDefaultIcons = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(sources) {
      var wixProvider, result;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              wixProvider = this.findProviderBySource(iconSources.WIX_NOUN_PROJECT_SOURCE);
              _context7.next = 3;
              return Promise.all([wixProvider.searchIconsWithSource(['generic'], {
                sources: sources
              })]).then(function (values) {
                var genericWixIcons = values[0];
                return [].concat(genericWixIcons);
              });

            case 3:
              result = _context7.sent;

              this._cacheSearchedIcons(result);

              return _context7.abrupt("return", result);

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, this);
    }));

    function getDefaultIcons(_x15) {
      return _getDefaultIcons.apply(this, arguments);
    }

    return getDefaultIcons;
  }();

  _proto.getIconsForIndustries = /*#__PURE__*/function () {
    var _getIconsForIndustries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(industryName, searchOptions) {
      var _searchOptions, _searchOptions$should, shouldShuffleCmsIcons, sources, wixProvider, result, wixIcons;

      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              if (searchOptions === void 0) {
                searchOptions = {};
              }

              _searchOptions = searchOptions, _searchOptions$should = _searchOptions.shouldShuffleCmsIcons, shouldShuffleCmsIcons = _searchOptions$should === void 0 ? true : _searchOptions$should, sources = _searchOptions.sources;
              wixProvider = this.findProviderBySource(iconSources.WIX_NOUN_PROJECT_SOURCE);
              _context8.next = 5;
              return wixProvider.searchIconsWithSource([industryName], {
                sources: sources,
                skipTranslate: true
              });

            case 5:
              result = _context8.sent;
              wixIcons = shouldShuffleCmsIcons ? shuffle(result) : result;

              this._cacheSearchedIcons(wixIcons);

              return _context8.abrupt("return", wixIcons);

            case 9:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, this);
    }));

    function getIconsForIndustries(_x16, _x17) {
      return _getIconsForIndustries.apply(this, arguments);
    }

    return getIconsForIndustries;
  }();

  _proto.getIconsByTag = /*#__PURE__*/function () {
    var _getIconsByTag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(tag) {
      var _this$options$cmsSour, cmsSourceForIcons, wixProvider, wixIcons;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _this$options$cmsSour = this.options.cmsSourceForIcons, cmsSourceForIcons = _this$options$cmsSour === void 0 ? iconSources.NEW_WIX_CMS : _this$options$cmsSour;
              wixProvider = this.findProviderBySource(iconSources.WIX_NOUN_PROJECT_SOURCE);
              _context9.next = 4;
              return wixProvider.searchIconsWithSource([tag], {
                sources: [cmsSourceForIcons],
                skipTranslate: true
              });

            case 4:
              wixIcons = _context9.sent;

              this._cacheSearchedIcons(wixIcons);

              return _context9.abrupt("return", wixIcons);

            case 7:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, this);
    }));

    function getIconsByTag(_x18) {
      return _getIconsByTag.apply(this, arguments);
    }

    return getIconsByTag;
  }();

  _proto.freeSearchIcons = /*#__PURE__*/function () {
    var _freeSearchIcons = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(arrSearchTerms, options) {
      var provider, result;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              provider = this.findProviderBySource(iconSources.NOUN_PROJECT_SOURCE);
              _context10.next = 3;
              return provider.searchIconsWithSource(arrSearchTerms, options);

            case 3:
              result = _context10.sent;

              this._cacheSearchedIcons(result);

              return _context10.abrupt("return", result);

            case 6:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, this);
    }));

    function freeSearchIcons(_x19, _x20) {
      return _freeSearchIcons.apply(this, arguments);
    }

    return freeSearchIcons;
  }();

  _proto.getWixVectorIcons = /*#__PURE__*/function () {
    var _getWixVectorIcons = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
      var options, provider, result;
      return _regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              options = {
                onlyWixLegacyIcons: true
              };
              provider = this.findProviderBySource(iconSources.NEW_WIX_CMS);
              _context11.next = 4;
              return provider.searchIconsWithSource([], options);

            case 4:
              result = _context11.sent;

              this._cacheSearchedIcons(result);

              return _context11.abrupt("return", result);

            case 7:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, this);
    }));

    function getWixVectorIcons() {
      return _getWixVectorIcons.apply(this, arguments);
    }

    return getWixVectorIcons;
  }();

  _proto.getIcons = function getIcons() {
    return this._icons;
  };

  _proto.getSearchTerm = function getSearchTerm() {
    return this._searchTerm;
  };

  _proto.getSearching = function getSearching() {
    return this._searching;
  };

  _proto.getSelectedTag = function getSelectedTag() {
    return this._selectedTag;
  };

  _proto.setSearchTerm = function setSearchTerm(term) {
    this._searchTerm = term;
    this.searchTermChanged.emit({
      searchTerm: this._searchTerm
    });
  };

  _proto.setSelectedTag = function setSelectedTag(tag) {
    this._selectedTag = tag;
    this.selectedTagChanged.emit({
      selectedTag: this._selectedTag
    });
  };

  _proto.setIcons = function setIcons(icons) {
    this._icons = icons;
    this.iconsChanged.emit({
      icons: icons
    });
  };

  _proto.setSearching = function setSearching(newState) {
    this._searching = newState;
    this.searchingChanged.emit({
      searching: newState
    });
  };

  _proto.clearSearchTerm = function clearSearchTerm() {
    this.setSearchTerm('');
  };

  _proto.clearSelectedTag = function clearSelectedTag() {
    this.setSelectedTag('');
  };

  _proto.getIconsByTagNew = /*#__PURE__*/function () {
    var _getIconsByTagNew = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(tag) {
      var tags, _yield$this$iconsServ, icons;

      return _regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              this.setSearching(true);
              this.clearSearchTerm();
              this.setSelectedTag(tag);
              tags = [tag];

              if (tag === 'Trendy') {
                tags = union(['generic', tag]);
              }

              _context12.next = 7;
              return this.iconsServerApi.getIconsByTags(tags);

            case 7:
              _yield$this$iconsServ = _context12.sent;
              icons = _yield$this$iconsServ.icons;
              this.setIcons(icons);

              this._cacheSearchedIcons(icons);

              this.setSearching(false);

            case 12:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, this);
    }));

    function getIconsByTagNew(_x21) {
      return _getIconsByTagNew.apply(this, arguments);
    }

    return getIconsByTagNew;
  }();

  _proto.getIconsByTerm = /*#__PURE__*/function () {
    var _getIconsByTerm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(term) {
      var _yield$this$iconsServ2, icons;

      return _regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              this.setSearching(true);
              this.setSearchTerm(term);
              this.clearSelectedTag();
              _context13.next = 5;
              return this.iconsServerApi.getIconsByTerm(term);

            case 5:
              _yield$this$iconsServ2 = _context13.sent;
              icons = _yield$this$iconsServ2.icons;
              this.setIcons(icons);

              this._cacheSearchedIcons(icons);

              this.setSearching(false);

            case 10:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, this);
    }));

    function getIconsByTerm(_x22) {
      return _getIconsByTerm.apply(this, arguments);
    }

    return getIconsByTerm;
  }();

  _proto.getIconsByIndustry = /*#__PURE__*/function () {
    var _getIconsByIndustry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(industry, options) {
      var _options2, _options2$shuffleCms, shuffleCms, _options2$isSuggested, isSuggestedTag, _yield$this$iconsServ3, icons;

      return _regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              if (options === void 0) {
                options = {};
              }

              this.setSearching(true);
              this.clearSearchTerm();
              _options2 = options, _options2$shuffleCms = _options2.shuffleCms, shuffleCms = _options2$shuffleCms === void 0 ? false : _options2$shuffleCms, _options2$isSuggested = _options2.isSuggestedTag, isSuggestedTag = _options2$isSuggested === void 0 ? false : _options2$isSuggested;

              if (isSuggestedTag) {
                this.setSelectedTag('Suggested');
              } else {
                this.clearSelectedTag();
              }

              _context14.next = 7;
              return this.iconsServerApi.getIconsByIndustry(industry, {
                shuffleCms: shuffleCms
              });

            case 7:
              _yield$this$iconsServ3 = _context14.sent;
              icons = _yield$this$iconsServ3.icons;
              this.setIcons(icons);

              this._cacheSearchedIcons(icons);

              this.setSearching(false);
              return _context14.abrupt("return", {
                icons: icons
              });

            case 13:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, this);
    }));

    function getIconsByIndustry(_x23, _x24) {
      return _getIconsByIndustry.apply(this, arguments);
    }

    return getIconsByIndustry;
  }();

  return LogoProviderManager;
}(EventEmitter);